angular.module('rjmNg.directives').directive "columnInput", [
  () ->
    restrict: "E"
    templateUrl: "directive.columnInput.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      inputId: "="
      col: "="
      table: "="
    controller: [
      "encodedLetterString"
      (
        encodedLetterString
      ) ->

        view = @
        view.indexToAlpha = (index) ->
          encodedLetterString.indexToAlpha(index, false)
        return view
    ]
]
